// src/components/Common/Newsletter.js
import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Ici, tu peux ajouter la logique pour envoyer l'email à ton backend ou service de newsletter.
    // Exemple basique :
    if (email.trim() === '') {
      setMessage('Veuillez entrer une adresse email valide.');
      return;
    }
    setMessage(`Merci pour votre inscription avec l'email : ${email}`);
    setEmail('');
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h2>S'inscrire à la Newsletter</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="email">Email :</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ margin: '10px', padding: '8px' }}
          required
        />
        <button type="submit" style={{ padding: '8px 16px' }}>S'inscrire</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default Newsletter;
